export default "__VITE_ASSET__B6$S8CgQ__"